<template>
  <v-col>
    <v-card v-if="driver">
      <v-btn color="grey" small class="tariff-left-headers">
        <h3>{{ $i18n.t("Current Address") }}</h3>
      </v-btn>
      <v-row style="padding: 10px 10px">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            :label="$i18n.t('Address Line')"
            v-model="driver.driverDetail.address.addressLine"
            maxlength="100"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-country-select v-model="driver.driverDetail.address.country" />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-state-select
            v-model="driver.driverDetail.address.state"
            :country="driver.driverDetail.address.country"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-city-select
            v-model="driver.driverDetail.address.city"
            :country="driver.driverDetail.address.country"
            :state="driver.driverDetail.address.state"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-card>
      <v-btn color="grey" small class="tariff-left-headers">
        <h3>{{ $i18n.t("Permanent Address") }}</h3>
      </v-btn>
      <v-row style="padding: 10px 10px">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-text-field
            :label="$i18n.t('Address Line')"
            v-model="driver.driverDetail.permanentAddress.addressLine"
            maxlength="100"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-country-select
            v-model="driver.driverDetail.permanentAddress.country"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-state-select
            v-model="driver.driverDetail.permanentAddress.state"
            :country="driver.driverDetail.permanentAddress.country"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <z-city-select
            v-model="driver.driverDetail.permanentAddress.city"
            :country="driver.driverDetail.permanentAddress.country"
            :state="driver.driverDetail.permanentAddress.state"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "Addresss",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Addresss extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
    if (!this.driver.driverDetail.address)
      this.driver.driverDetail.address = {};
    if (!this.driver.driverDetail.permanentAddress)
      this.driver.driverDetail.permanentAddress = {};
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>